import React, { useEffect, useMemo, useRef, useState } from "react";
import { cart2, deleteIcon } from "../assets/img";
import { Table } from "../Component/Table/Table";
import { Toast } from "../Component/Toast";
import { deletes, get, post } from "../Services/ApiHandler";
import { URLS } from "../Services/Constant";
import useStore from "./redux/store/useStore";
import { useLocation, useNavigate } from "react-router-dom";
import { FullTable } from "../Component/Table/FullTable";
import moment from "moment";
import CustomScroll from "../Component/CustomScroll";
import Loader from "../Component/Loader";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { saveCartList } from "./redux/slice/cartList";
import RawWebSocket from "../Websocker/RawWebSocket";
import useStoreKv from "../LocalStore/useStore";
import SubmitButton from "../Component/SubmitButton";

const Cart = () => {
  const cart = useSelector((state) => state.cartList);
  const dispatch = useDispatch();
  const [showMessage, setShowMessage] = useState("");
  const [popup, setPopup] = useState(false);
  const [popup2, setPopup2] = useState(false);
  const [popup4, setPopup4] = useState(false);
  const [popup3, setPopup3] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useStore();
  const navigation = useNavigate();
  const userId = user?.id;
  const slotsGameExpiriedIds = useRef(new Set());
  const empiryTimeOutIds = useRef([]);
  const [loader, setLoader] = useState(false);

  const kvStore = useStoreKv();
  const walletCount = kvStore.kv?.walletAmount ?? 0;
  // const [walletCount, setWalletCount] = useState();
  const [_, setCart] = useState([]);
  const deleteQueueRef = useRef(new Map()); // Store delete promises for tracking

  const totalAmount = cart.reduce(
    (sum, item) => sum + (item.ticket_amount || 0),
    0,
  );

  const location = useLocation();

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          const el = document.querySelector(".cart-container"); // 👈 your scroll container
          if (el) {
            el.scrollTo({ top: 0, behavior: "smooth" });
          }
        }, 0);
        // getList("footer");
      }
    }
  }, [location]);

  // Function to check closed or open
  const checkBookingClosed = (bookingTime) => {
    if (!bookingTime) return false;

    // Convert "2025-12-06 23:00:00" → "2025-12-06T23:00:00"
    const bookingDate = new Date(bookingTime.replace(" ", "T"));
    const now = new Date();

    return now > bookingDate; // true = closed
  };

  const bookingTime = localStorage.getItem("bookingTime");
  const isClosed = checkBookingClosed(bookingTime);

  // // console.log("isClosed:", isClosed);

  useEffect(() => {
    const onPopState = () => {
      navigation("/home", { replace: true });
    };

    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, [navigation]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Lot Details",
        accessor: "lot_details",
        Cell: ({ value }) => {
          const text = value || "";

          // Look for DEAR or KERALA anywhere in the string
          const match = text.match(/\b(dear|kerala)\b/i);

          let firstLine = text.trim();
          let secondLine = "";

          if (match) {
            const index = match.index;

            firstLine = text.substring(0, index).trim();
            secondLine = text.substring(index).trim();
          }

          return (
            <div>
              <p>{firstLine}</p>
              {secondLine && <p>{secondLine}</p>}
            </div>
          );
        },
      },

      {
        Header: "NO's",
        accessor: "my_number",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Qty",
        accessor: "count",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "₹",
        accessor: "price",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: () => (
          <div style={{ textAlign: "center", lineHeight: "1.2" }}>
            <div>Ticket</div>
            <div>₹</div>
          </div>
        ),
        accessor: "ticket_amount",
        Cell: ({ row, value }) => {
          return (
            <p style={{ width: 30 }} className="text-nowrap">
              {value}
            </p>
          );
        },
      },
      {
        Header: "",
        accessor: "delete",
        Cell: ({ row }) => {
          const itemId = row.original.id;
          const isDeleting = deleteQueueRef.current.has(itemId);

          return (
            <div style={{ width: "100%", textAlign: "center" }}>
              <button
                className="delete-btn"
                onClick={() => onDelete(row.original)}
                disabled={isDeleting}
              >
                {/* {isDeleting ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                        style={{ color: "black", padding: 8 }}
                                    ></span>
                                ) : ( */}
                <img
                  src={deleteIcon}
                  alt=""
                  style={{ width: 16, height: 16 }}
                />
                {/* )} */}
              </button>
            </div>
          );
        },
      },
    ],
    [cart], // Add cart dependency to re-render when cart changes
  );

  const updateToReduxCart = (data) => {
    dispatch(saveCartList(data));
  };

  const onDelete = async (item) => {
    if (!item?.id) return;

    // Mark as deleting in the queue
    deleteQueueRef.current.set(item.id, true);

    // IMMEDIATE LOCAL REMOVAL - Remove from cart immediately
    const currentCart = [...cart];
    const updatedCart = currentCart.filter(
      (cartItem) => cartItem.id !== item.id,
    );
    console.log("cart delete", currentCart, updatedCart);
    // Update state and localStorage immediately
    updateToReduxCart(updatedCart);
    localStorage.setItem("cart", JSON.stringify(updatedCart));

    try {
      let payload = { user_id: userId, cart_ids: [item?.id] };
      RawWebSocket.emit("cart_delete", payload);
    } catch (err) {
      console.log("Delete API error:", err);
    } finally {
      // Remove from delete queue
      deleteQueueRef.current.delete(item.id);
    }
  };

  const handlePress = async () => {
    if (!cart || cart?.length === 0) return;

    try {
      setLoading(true);

      let payload = {
        cart_ids: cart?.map((item) => item?.id),
        total_fee_amount: totalAmount,
        submit_time: moment().toISOString(),
      };
      // // console.log("payload check", payload);
      const res = await post(`${URLS.SLOTLIST}/play`, payload);

      if (res.status === "success") {
        setShowMessage(res?.message);
        // Toast(res?.message || "Processed successfully.");
        updateToReduxCart([]);
        localStorage.removeItem("cart");
        setPopup(false);
        setPopup3(true);
      } else {
        setPopup(false);
      }
    } catch (err) {
      // // console.log("err", err);
      setPopup(false);
    } finally {
      setLoading(false);
      setPopup(false);
    }
  };

  const handleClearCart = async (booking) => {
    updateToReduxCart([]);
    localStorage.removeItem("cart");
    try {
      setLoading(true);
      RawWebSocket.emit("clear_cart", { client_id: userId });
      // const resClear = await post(`${URLS.ADDGAME}/clear`);

      if (booking === true) {
        setPopup4(true);
      } else {
        // Toast(resClear?.message || "Cart cleared successfully.");
      }
      updateToReduxCart([]);
      setPopup2(false);
    } catch (err) {
      // // console.log(err);
    } finally {
      setLoading(false);
    }
    empiryTimeOutIds.current?.forEach((id) => clearTimeout(id));
    empiryTimeOutIds.current = [];
  };

  return (
    <>
      <div className="cart-container dashRightView-foot">
        <CustomScroll>
          {/* Header */}
          <div className="cart-header">
            <span className="f3 cart-notice">
              Pay before Booking closing time
            </span>
            <button
              className="cart-clear-btn f1"
              onClick={() => setPopup2(true)}
            >
              <img src={cart2} alt="cart"  style={{ filter: "brightness(0) invert(1)" }}  width={16} height={16} />
              Clear Cart
            </button>
          </div>

          {/* Table */}
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <FullTable columns={columns} data={cart} />
          </div>
          {/* Total & Confirm */}
          <div style={{ marginBottom: 65 }} className="flexendtotal">
            <div className="cart-total">
              <h3 style={{ color: "#fff" }} className="f2">
                Total Price: ₹{" "}
                {Number(
                  totalAmount % 1 === 0 ? totalAmount : totalAmount.toFixed(2),
                )}
              </h3>
            </div>
            <div className="cart-confirm">
              {/* <button
                className={
                  cart?.length === 0 ? "confirm-btn-Dis" : "confirm-btn"
                }
                disabled={cart?.length === 0}
                onClick={() => setPopup(true)}
              >
                Confirm Pay
              </button> */}
              <SubmitButton
                title="Confirm Pay"
                disabled={cart?.length === 0}
                onClick={() => setPopup(true)}
                isFormValid={cart?.length === 0}
              />
            </div>
          </div>
        </CustomScroll>
      </div>

      {popup3 && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              {showMessage}
            </p>
            <div
              style={{ paddingTop: 20 }}
              className="d-flex ac-je px-2 f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19"
            >
              <button
                onClick={() => {
                  setPopup3(false);
                }}
                className="yes-btn w-40"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

      {popup4 && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              Your cart has been cleared because the booking time has closed❗
            </p>
            <div
              style={{ paddingTop: 20 }}
              className="d-flex ac-je px-2 f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19"
            >
              <button
                onClick={() => {
                  setPopup4(false);
                }}
                className="yes-btn w-40"
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Wallet Low Popup */}
      {popup &&
        (walletCount > totalAmount ? (
          <div className="img-popup-design">
            <div className="img-popup">
              <p style={{ color: "#1B1B1B" }} className="f2">
                Are you sure, you want to confirm to pay !
              </p>

              <div className="d-flex ac-jb pt-4 f3">
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>

                <button onClick={handlePress} className="yes-btn w-40">
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  ) : (
                    "Okay"
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="img-popup-design">
            <div className="img-popup">
              <p style={{ color: "#1B1B1B" }} className="f2">
                Your Wallet Balance is Low, Kindly recharge your wallet !
              </p>

              <div className="d-flex ac-jb pt-4 f3">
                <button onClick={() => setPopup(false)} className="no-btn w-40">
                  No
                </button>

                <button
                  onClick={() => {
                    setPopup(false);
                    navigation("/recharge");
                  }}
                  className="yes-btn w-40"
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  ) : (
                    "Okay"
                  )}
                </button>
              </div>
            </div>
          </div>
        ))}

      {/* Clear Cart Popup */}
      {popup2 && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p style={{ color: "#1B1B1B" }} className="f2">
              Are you sure, want to clear cart ?
            </p>
            <div className="d-flex ac-jb pt-4 f3">
              <button onClick={() => setPopup2(false)} className="no-btn w-40">
                No
              </button>

              <button onClick={handleClearCart} className="yes-btn w-40">
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "white", padding: 8 }}
                  ></span>
                ) : (
                  "Yes"
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      {loader && <Loader />}
    </>
  );
};

export default Cart;
